export function isCustomEvent<SomeEvent extends CustomEvent>(
    event:Event,
    test?:(event:CustomEvent) => boolean,
): event is SomeEvent {
    return 'detail' in event && 'initCustomEvent' in event && (test === undefined || test(event as CustomEvent));
}

export function setUpOptimizelyTest<SomeEvent extends CustomEvent>(
    optimizelyEvent:string,
    callback:(event:SomeEvent) => unknown,
    test?:(event:CustomEvent) => event is SomeEvent,
) {
    function eventListener(event: Event) {
        if (isCustomEvent<SomeEvent>(event, test)) {
            callback(event);
        }
    }
    window.addEventListener(optimizelyEvent, eventListener);
    // Return event in case we need to remove the listener
    return eventListener;
}
